// *****************************************************************
// システム上のタイプ
// *****************************************************************
/** ヘッダのタイプ */
export const HEADER_TYPE = {
  NONE_LOGIN: 1,
  LOGIN: 2
}

// *****************************************************************
// 仕様上のタイプ
// *****************************************************************

/** 業務タイプ */
export const CORP_TYPE = {
  ARCHITECT_OFFICE: {code: 0, label: '設計事務所'},
  DESIGN_OFFICE: {code: 1, label: 'デザイン事務所'},
  REHOME_CORP: {code: 2, label: 'リフォーム会社'},
  INTERIA: {code: 3, label: 'インテリアコーディネーター'},
  SEKOO_CORP: {code: 4, label: '設計施工会社'},
  KOMU: {code: 5, label: '工務店'},
  KENCHIKU: {code: 6, label: '建設会社'},
  GENERAL_CONSTRUCTOR: {code: 7, label: 'ゼネコン'},
  CRAFTOR: {code: 8, label: '職人'},
  SEKO_SHOP: {code: 9, label: '施工店'},
  HOUSE_MAKER: {code: 10, label: 'ハウスメーカー'},
  DEVELOPER: {code: 11, label: 'デベロッパー'},
  REAL_ESTATE: {code: 12, label: '不動産業'},
  LEASE_CORP: {code: 13, label: '賃貸管理会社'},
  TRADE_CORP: {code: 14, label: '商社'},
  FURNITURE_CORP: {code: 15, label: '家具製作会社'},
  HOME_BESINESS: {code: 16, label: '大家業 施主(法人)'},
  FURNITURE_RETAIL: {code: 17, label: '家具小売・卸売'},
  OTHER: {code: 99, label: 'その他'}
}

/** dcをどこで知りましたか？ */
export const INFO_SRC = {
  NEWS: {code: 0, label: '新聞・雑誌・ニュース'},
  MAGAZINE: {code: 1, label: '専門誌・業界紙'},
  SHOW: {code: 2, label: '展示会'},
  SEMINAR: {code: 3, label: 'セミナー'},
  DIRECT_MESSAGE: {code: 4, label: 'DM'},
  SNS: {code: 5, label: 'SNS'},
  INVITE_FRIENDS: {code: 6, label: '知人からの紹介'},
  INVITE_CORP: {code: 7, label: '所属企業からの招待'},
  OTHER: {code: 99, label: 'その他'}
}

/** お問い合わせカテゴリ */
export const SUPPORT_TYPE = {
  SAFACE_SAMPLE: {code: 1, label: '面材サンプルについて'},
  ORDER_ITEM: {code: 2, label: '商品をオーダーしたい'},
  ITEM: {code: 3, label: '商品について'},
  ORDER_SETP: {code: 4, label: '注文方法について'},
  CONST_SERVICE: {code: 5, label: '組立設置サービスについて'},
  ORDERED_ITEM: {code: 6, label: '注文した商品について'},
  OTHER: {code: 99, label: 'その他のお問い合わせ'}
}

/** お問い合わせメーカー */
export const SUPPORT_MAKER = {
  FUNITURE_MAKER: {code: 27, label: 'ファニチャーメーカー株式会社'},
  MIURA: {code: 1001, label: '株式会社みうら'},
  TECMA: {code: 1070, label: 'アクシス株式会社/株式会社テクマ'},
  DOMANS: {code: 300, label: 'ドゥーマンズ株式会社'}
}

/** オプションタイプ */
export const OPTION_TYPE = {
  FILLER: {code: 1, label: 'フィラー'},
  OTHER: {code: 9, label: 'その他'}
}

/** カラー素材タイプ */
export const COLOR_MATERIAL_TYPE = {
  CABINE: {code: 1, label: 'キャビネット'},
  DOOR: {code: 2, label: 'ドア'},
  COUNTER: {code: 3, label: 'カウンター'}
}

/** ユーザー種別 */
export const USER_TYPE = {
  DC_ADMIN: {code: 'DC_ADMIN', label: '管理者'},
  DC_USER: {code: 'DC_USER', label: '使用者'}
}

/** ご自宅のタイプ */
export const HOME_TYPE = {
  HOUSE: {code: 1, label: '戸建'},
  LEASE: {code: 2, label: 'マンション・アパート'}
}



// WEBPACK FOOTER //
// ./src/main/js/payment/constants/TypeEc.js